import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { toast } from "sonner";
import { isPlaceholder } from "@/config/site";
import { scrollToId } from "./motion";

export const CtaButton = ({ children, href, target, onClick, testId, className = "", variant = "sun" }) => {
  const styles = {
    sun: "bg-sun text-ink shadow-[0_14px_40px_-12px_rgba(255,190,40,0.9)]",
    ink: "bg-ink text-white",
    ghost: "bg-white text-ink ring-2 ring-ink/15",
  };
  const handle = (e) => {
    if (onClick) { e.preventDefault(); onClick(); return; }
    if (target) { e.preventDefault(); scrollToId(target); return; }
    if (isPlaceholder(href)) {
      e.preventDefault();
      toast("Link de checkout ainda não configurado", { description: `Substitua ${href} em src/config/site.js` });
    }
  };
  return (
    <motion.a
      href={href || (target ? `#${target}` : "#")}
      target={href && !isPlaceholder(href) ? "_blank" : undefined}
      rel="noopener noreferrer"
      onClick={handle}
      data-testid={testId}
      whileHover={{ scale: 1.03 }}
      whileTap={{ scale: 0.97 }}
      className={`cta-shine group relative inline-flex items-center justify-center gap-3 overflow-hidden rounded-full px-7 py-4 text-center font-display text-base font-extrabold uppercase tracking-wide sm:text-lg ${styles[variant]} ${className}`}
    >
      <span className="relative z-10">{children}</span>
      <ArrowRight className="relative z-10 h-5 w-5 shrink-0 transition-transform duration-300 group-hover:translate-x-1" />
    </motion.a>
  );
};
